'use strict';

class SSAwsService {
    constructor($log, SSUtilService, SSHttpService, SSAlertService, Upload) {
        const self = this;

        self.$log = $log;
        self.SSUtilService = SSUtilService;
        self.SSHttpService = SSHttpService;
        self.SSAlertService = SSAlertService;
        self.Upload = Upload;

        self.appServiceObject = SSUtilService.defineStorageDefault('def_app_service');

        self.init();
    }

    init() {
        const self = this;
    }

    upload(file, policyUrlOrObject, callback) {
        const self = this;

        if (typeof policyUrlOrObject == "string") {
            self.policy(policyUrlOrObject, function (policyDocument) {
                self._upload(file, policyDocument, callback);
            });
        } else {
            self._upload(file, policyUrlOrObject, callback);
        }
    }

    uploadAPIRequest(file, policyUrlOrObject, callback, fileName = null) {
        const self = this;

        if (typeof policyUrlOrObject == "string") {
            self.policyAPIRequest(policyUrlOrObject, function (policyDocument) {
                self._upload(file, policyDocument, callback, fileName);
            });
        } else {
            self._upload(file, policyUrlOrObject, callback, fileName);
        }
    }

    policy(url, callback) {
        const self = this;

        self.SSHttpService.getRequest(url).then(function (response) {
            if (response instanceof Error) {
                if (response.code == 401) {
                    self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                } else if (response.code == 500) {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                }
                return;
            }
            callback(response.data.policy);
        });
    }

    policyAPIRequest(url, callback) {
        const self = this;

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            callback(response.data.policy);
        });
    }

    _upload(file, policy, callback, fileName = null) {
        const self = this;

        let randomName = self.SSUtilService.getRandomName()
        let filepath = policy.path + '/' + (fileName ? fileName : randomName );
        let ext = self.SSUtilService.getFileExtension(file.name);

        if(!filepath.endsWith("." + ext)){
            filepath = ext ? filepath + '.' + ext : '';
        }

        // Per AWS S3 form-POST rules the `file` field MUST be the last entry in the multipart
        // body — anything appended after it is silently dropped. ng-file-upload serializes the
        // FormData in object-key insertion order, so build every metadata field first, then
        // assign `file` last.
        //
        // Only include fields the server's signed POST policy whitelists. Sending an unknown
        // field causes S3 to reject with "Invalid according to Policy: Extra input fields: <name>".
        // randomname/extension are computed locally to build the upload path — they are NOT
        // part of any signed policy and must NOT be sent. They are reattached to
        // response.config.data after upload completes so legacy callers (super/cms/cms.js)
        // can still read them.
        let data = {
            key: filepath, // the key to store the file on S3, could be file name or customized
            AWSAccessKeyId: policy.key,
            policy: policy.document, // base64-encoded json policy (see article below)
            signature: policy.signature, // base64-encoded signature based on policy string (see article below)
            'Content-Type': self.SSUtilService.getUploadContentType(file), // stored on the S3 object (WEB-4845)
            filename: filepath // this is needed for Flash polyfill IE8-9
        };

        // Only include acl when the server's signed policy carries one. With S3 Block Public
        // Access enabled and AWS_USE_OBJECT_ACLS=false on the API, policy.acl is "" / null
        // and S3 rejects the POST as "Invalid according to Policy: Extra input fields: acl".
        if (policy.acl) {
            data.acl = policy.acl;
        }

        data.file = file; // MUST stay last — see field-ordering note above.

        self.Upload.upload({
            url: self.appServiceObject.serverConfig.assets_host,
            method: 'POST',
            headers: {'Authorization': undefined}, // Don't send Authorization headers to S3
            data: data
        }).then(function (response) {
            // response.config.data.key
            // response.config.data.file.name
            // Expose locally-computed metadata so callers (e.g. super/cms/cms.js) can build
            // file names without us having to send these as S3 form fields.
            response.config.data.randomname = randomName;
            response.config.data.extension = ext;
            callback(response);
        }, function (response) {
            console.error('Error: ' + response.status);
            self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('Progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        });
    }

    post(url, params) {
        const self = this;

        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                console.error('Error while adding/updating asset file.');
                console.error(response);

                if (response.code == 401) {
                    self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                } else if (response.code == 500) {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                }
                return;
            }

            console.log('Asset file has been uploaded successfully.');
            self.SSAlertService.success('Success!', 'File uploaded successfully.');
        });
    }

}

SSAwsService.$inject = ['$log', 'SSUtilService', 'SSHttpService', 'SSAlertService', 'Upload'];
app.service('SSAwsService', SSAwsService);